/**
 * @generated SignedSource<<507599d2e539fede27f46a2a037bb471>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerOrder_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskBrowseByTopic_viewer" | "GetHelpZendeskSellerOrderTile_viewer" | "GetHelpZendeskSellerPopularArticles_viewer">;
  readonly " $fragmentType": "GetHelpZendeskSellerOrder_viewer";
};
export type GetHelpZendeskSellerOrder_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerOrder_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerOrder_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerOrder_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerOrderTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskBrowseByTopic_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerPopularArticles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "219fe16f55fbb2b8a19df99a623c8215";

export default node;
